import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnVisibleDirective } from './on-visible.directive';

@NgModule({
  declarations: [OnVisibleDirective],
  exports: [OnVisibleDirective],
  imports: [CommonModule],
})
export class OnVisibleModule {}
